module.exports = __webpack_public_path__ + "assets/stand13w.a93184c42a84576b3e335d2516b1444d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/stand13w.png
 ** module id = 182
 ** module chunks = 0
 **/